// Financial years - dynamically generated based on current date
// Indian FY runs April to March, so:
// - If current month is Jan-Mar, current FY started last calendar year
// - If current month is Apr-Dec, current FY started this calendar year
export const getFinancialYears = (count = 3) => {
  const now = new Date();
  const currentMonth = now.getMonth(); // 0-11
  const currentYear = now.getFullYear();

  // Determine the start year of the current financial year
  // If Jan-Mar (months 0-2), FY started previous year
  // If Apr-Dec (months 3-11), FY started this year
  const currentFYStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;

  const years = [];
  for (let i = 0; i < count; i++) {
    const startYear = currentFYStartYear - i;
    const endYear = (startYear + 1).toString().slice(-2);
    years.push({
      value: `${startYear}-${endYear}`,
      label: `FY ${startYear}-${endYear}`
    });
  }

  return years;
};

// Indian Tax Slabs - New Regime FY 2025-26
export const TAX_SLABS_NEW_REGIME_2025 = [
  { min: 0, max: 300000, rate: 0 },
  { min: 300000, max: 700000, rate: 5 },
  { min: 700000, max: 1000000, rate: 10 },
  { min: 1000000, max: 1200000, rate: 15 },
  { min: 1200000, max: 1500000, rate: 20 },
  { min: 1500000, max: Infinity, rate: 30 }
];

// Tax deductions
export const STANDARD_DEDUCTION = 75000; // FY 2025-26
export const SECTION_44ADA_PRESUMPTIVE_RATE = 0.5; // 50% of revenue is profit

// Budget alert threshold - show alert when budget usage reaches this percentage
export const BUDGET_ALERT_THRESHOLD = 75;

// Advance tax due dates (Indian FY)
export const ADVANCE_TAX_DUE_DATES = [
  { quarter: 1, dueDate: 'June 15', percentage: 15 },
  { quarter: 2, dueDate: 'September 15', percentage: 45 },
  { quarter: 3, dueDate: 'December 15', percentage: 75 },
  { quarter: 4, dueDate: 'March 15', percentage: 100 }
];
